import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { REACT_APP_SENTRY_URL } from '../config';
import { App } from './app';

if (process.env.NODE_ENV === 'production') {
	disableReactDevTools();
}

const root = createRoot(document.getElementById('root') as HTMLElement);

Sentry.init({
	dsn: REACT_APP_SENTRY_URL,
});

root.render(
	<StrictMode>
		<App />
	</StrictMode>,
);
